import { sanitizePath } from "../../../utils/sanitizePath";

const ALLOWED_MIME_TYPES = ["application/pdf"];

const ALLOWED_EXTENSIONS = ["pdf"];

const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB

const validateFile = (file: any): void => {
  if (!file) {
    throw new Error("No file provided");
  }
  if (!ALLOWED_MIME_TYPES.includes(file.type)) {
    throw new Error(`File type "${file.type}" is not allowed`);
  }
  if (file.size > MAX_FILE_SIZE) {
    throw new Error("File size exceeds the 50 MB limit");
  }
  const ext = file.name?.split(".")?.pop()?.toLowerCase();
  if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
    throw new Error(`File extension ".${ext}" is not allowed`);
  }
};

export const uploadDpsToS3 = async ({
  file,
  caseId,
  inmateName,
  request,
}: any) => {
  validateFile(file);

  const timestamp = Date.now();
  const folderName = "Uploaded Documents";
  const sanitizedInmate = sanitizePath(inmateName);
  const sanitizedCaseId = sanitizePath(caseId);
  const extension = sanitizePath(file.name.split(".").pop()) || "bin";
  const fileName = sanitizePath(file.name) || `Report-${timestamp}.${extension}`;

  const presignedResponse = await request.post("/api/aws/pre-signed-url", {
    fileName: fileName,
    fileType: file.type,
    folderName,
    caseId: sanitizedCaseId,
    inmateName: sanitizedInmate,
  });

  const { signedUrl, key: firstKey } = presignedResponse.data;

  const uploadResponse1 = await fetch(signedUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!uploadResponse1.ok) {
    throw new Error(`Upload failed: ${uploadResponse1.statusText}`);
  }

  // const destinationKey = `Cases/${sanitizedInmate}-${sanitizedCaseId}/${folderName}/${fileName}`;

  const presignedResponse2 = await request.post("/api/aws/pre-signed-url", {
    fileName: fileName,
    fileType: file.type,
    folderName,
    caseId: sanitizedCaseId,
    inmateName: sanitizedInmate,
  });

  const { signedUrl: signedUrl2, key: destinationKeyResult } =
    presignedResponse2.data;

  const uploadResponse2 = await fetch(signedUrl2, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!uploadResponse2.ok) {
    throw new Error(`Copy upload failed: ${uploadResponse2.statusText}`);
  }

  return { Location: signedUrl2.split("?")[0], Key: destinationKeyResult };
};
